// extracted by mini-css-extract-plugin
export default {"C":"CouncilDistrictBadge__C___ZepGd","D":"CouncilDistrictBadge__D___fbFNP","SD":"CouncilDistrictBadge__SD___nrUBB"};